import './gallery-slider.scss'

export default {
    name: 'gallery-slider',

    data: {
        index: 0,
        imagesDisplay: 4,
        size: 'full',
        timeout: null
    },

    computed: {
        barWidth () {
            return `${(100 / this.imagesDisplay) * this.images.length}%`
        },

        barTranslate () {
            return `translateX(${(100 / this.images.length) * this.index * -1}%)`
        }
    },

    mounted () {
        if (this.size === 'full') {
            const mqSmall = _.find(window.theme.mediaquery.get(), mqObj => mqObj.name === 'small')
            const mqMedium = _.find(window.theme.mediaquery.get(), mqObj => mqObj.name === 'medium')
            const mqLarge = _.find(window.theme.mediaquery.get(), mqObj => mqObj.name === 'large')
            const mqWide = _.find(window.theme.mediaquery.get(), mqObj => mqObj.name === 'wide')

            mqSmall.mql.addListener(e => { if (e.matches) { this.imagesDisplay = 1 } })
            mqMedium.mql.addListener(e => { if (e.matches) { this.imagesDisplay = 2 } })
            mqLarge.mql.addListener(e => { if (e.matches) { this.imagesDisplay = 4 } })
            mqWide.mql.addListener(e => { if (e.matches) { this.imagesDisplay = 4 } })

            if (mqSmall.mql.matches) { this.imagesDisplay = 1 }
            if (mqMedium.mql.matches) { this.imagesDisplay = 2 }
            if (mqLarge.mql.matches) { this.imagesDisplay = 4 }
            if (mqWide.mql.matches) { this.imagesDisplay = 4 }
        }

        if (this.size === 'small') {
            this.imagesDisplay = 1
        }

        // set gallery
        lightGallery(this.$refs.bar)

        // set timeout
        this.setTimeout()
    },

    methods: {
        setTimeout () {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                this.index = (this.index + 1 === (this.images.length - this.imagesDisplay + 1)) ? 0 : this.index + 1
                this.setTimeout()
            }, 5000)
        },

        next () {
            this.index = (this.index + 1 === (this.images.length - this.imagesDisplay + 1)) ? this.index : this.index + 1
            this.setTimeout()
        },

        prev () {
            this.index = (this.index - 1 < 0) ? this.index : this.index - 1
            this.setTimeout()
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/gallery-slider/gallery-slider.js